import { universitiesCountryMap } from 'src/features/details-form/constants';

const combinedUniversities = [...universitiesCountryMap.en, ...universitiesCountryMap.es];

export function parseThirdPartyUniversity(universityFromUrl?: string): string {
    if (!universityFromUrl) return '';

    const decodedUniversity = decodeURIComponent(universityFromUrl).trim().toLowerCase();

    const match = combinedUniversities.find((uni) => uni.toLowerCase() === decodedUniversity);

    return match || '';
}
